import React from 'react';
import fr from 'facet-rest';
import { pickWithPriority } from 'Helpers/Affordances';
import { useSmartAllocationCustomizationContext } from '../../Context';
import ResetButton from './ResetButton';

const ResetButtonPicker = () => {
  const { smartAllocCustResource } = useSmartAllocationCustomizationContext();

  const Component = pickWithPriority(smartAllocCustResource, [
    [fr.relationships.reset.name, ResetButton],
  ], null);

  if (!Component) {
    return null;
  }

  return <Component />;
};

export default ResetButtonPicker;
